@use "variables" as *;

.container {
  position: relative;
  display: flex;
  border-radius: 20px !important;
}

.cardArea {
  padding: $spacing-s !important;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 56px;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.inactiveCard {
  font-size: $fontSize-xxs;
  padding: 0 $spacing-xs;
  text-align: center;
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-s;
  margin-right: $spacing-s;
}

.name {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.brand {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: normal;
}

.profile {
  font-size: $fontSize-xxs;
  font-weight: normal;
  margin-bottom: $spacing-s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
